import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { authKeys, RequestTypes } from '@core/react-query/features/auth'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useVerifyMFASessionCode = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['verifyMFASession']
  >,
) => {
  return useMutation({
    ...authKeys.verifyMFASession,
    ...options,
  })
}
